var _rect, _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipeTurnsDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PipeTurnsDown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91,9.25a2.75,2.75,0,0,1-2,1.12,2.62,2.62,0,0,1,0-5.24,2.62,2.62,0,0,1,1.9,1",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.89,
    y1: 7.75,
    x2: 15.7,
    y2: 7.75,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.91,
    y1: 6.4,
    x2: 4.91,
    y2: 8.92,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeTurnsDown);
export default __webpack_public_path__ + "static/media/PipeTurnsDown.f022d32e21371b503f63d9f804d21a68.svg";
export { ForwardRef as ReactComponent };